export default {
  getTickets: (state) => state.tickets,
  getTicketsContext: (state) => state.ticketsContext,
  getTicket: (state) => (id) => {
    return state.tickets.find(ticket => ticket.id === parseInt(id))
  },
  getEmptyTicket: (state) => JSON.parse(JSON.stringify(state.emptyTicket)),
  getTicketsIndicator: (state) => state.ticketsIndicator,
}